import { STATUS_INIT } from 'constants/statuses.constants';

export const getInitialState = () => ({
  projects: [],
  status: STATUS_INIT,
  error: null,
});
